<agpr-take-over-panel
    [id]="id + '_takeOverPanel'"
    class="agpr-mentionVolumeEstimateDialog"
    header="Monitoring.mentionVolumeEstimateDialog.header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="handleVisibleChange($event)"
    [minPanelWidth]="650"
    [maxPanelWidth]="650"
    [responsiveWidth]="true"
>
    <div
      class="agpr-mentionVolumeEstimateDialog-content"
      [agprLoading]="loading"
    >
        @if (!quotaInfo) {
          <agpr-message
            class="agpr-mentionVolumeEstimateDialog-message"
            [severity]="messageSeverities.noContent"
            [bottomMargin]="false"
          >
            {{'Monitoring.mentionVolumeEstimateDialog.notAvailable' | localize }}
          </agpr-message>
        }
        @else {
          <agpr-message
            class="agpr-mentionVolumeEstimateDialog-message"
            [severity]="messageSeverities.info"
            [bottomMargin]="false"
          >
            {{'Monitoring.mentionVolumeEstimateDialog.infoMessage' | localize }}
          </agpr-message>
          <div class="agpr-mentionVolumeEstimateDialog-estimateRange">
            <label class="agpr-mentionVolumeEstimateDialog-estimateRangeLabel">
              {{ 'Monitoring.mentionVolumeEstimateDialog.estimateRangeLabel' | localize }}
            </label>
            <span class="agpr-mentionVolumeEstimateDialog-estimateRangeValue">
              {{ lowerBound | number }} - {{ upperBound | number }}
            </span>
          </div>
          <div
            class="agpr-mentionVolumeEstimateDialog-estimateChartWrapper"
          >
            <label class="agpr-mentionVolumeEstimateDialog-estimateChartLabel">
              {{ 'Monitoring.mentionVolumeEstimateDialog.estimateChartLabel' | localize }}
            </label>
            <agpr-chart
                class="agpr-mentionVolumeEstimateDialog-estimateChart"
                [chart]="estimateChart"
            ></agpr-chart>
          </div>
        }
        <agpr-button
            [id]="id + '_viewUsageDashboard'"
            class="agpr-mentionVolumeEstimateDialog-button"
            [style]="buttonTypes.tertiary"
            label="Monitoring.mentionVolumeEstimateDialog.viewUsageDashboard"
            (click)="openMentionSavingUsageDashboard()"
        ></agpr-button>
    </div>
    <ng-template #takeOverFooterRight>
      <agpr-button
        [id]="id + '_done'"
        [style]="buttonTypes.primary"
        label="done"
        (click)="close()"
      >
      </agpr-button>
    </ng-template>
</agpr-take-over-panel>

